/* global pendo */
import * as commonHelpers from '../common';
import { isLoadedFromHiMarleyConnect } from '@app/helpers/platform';

export const getGroupNames = (groups = [], groupLeads = []) => {
  const groupNames = groups?.map((group) => group.name) || [];
  const groupLeadNames = groupLeads?.map((groupLead) => groupLead.name) || [];
  return [...new Set([...groupNames, ...groupLeadNames])];
};

export const identify = (user) => {
  if (isLoadedFromHiMarleyConnect()) {
    return;
  }
  const org = user?.ownerOrganization;
  const { MARLEY_ACTIVE_ACCOUNT } = process.env;
  try {
    pendo.identify({
      visitor: {
        id: commonHelpers.getObjectId(user),
        displayName: `${user?.firstName} ${user?.lastName}`,
        email: user?.email,
        uniqueId: user?.oktaUserId,
        roles: user?.roles,
        groupNames: getGroupNames(user?.groups, user?.groupLeads),
      },
      account: {
        id: commonHelpers.getObjectId(org),
        name: org?.name,
        creationDate: org?.createdAt,
        environment: MARLEY_ACTIVE_ACCOUNT,
        permissions: user?.permissions,
      },
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Pendo.js error', err);
  }
};
